import { useQuery } from '@tanstack/react-query';
import { fetchFirmwares, fetchFirmwareCount } from '../api/firmware';
import type { FirmwareQueryParams, FirmwareCountParams } from '../types';

export const firmwareKeys = {
  list: (modelId: number, params: FirmwareQueryParams) =>
    ['firmwares', modelId, params] as const,
  count: (modelId: number, params: FirmwareCountParams) =>
    ['firmwares', 'count', modelId, params] as const,
};

export function useFirmwares(modelId: number, params: FirmwareQueryParams) {
  return useQuery({
    queryKey: firmwareKeys.list(modelId, params),
    queryFn: () => fetchFirmwares(modelId, params),
    enabled: modelId > 0,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}

export function useFirmwareCount(modelId: number, params: FirmwareCountParams) {
  return useQuery({
    queryKey: firmwareKeys.count(modelId, params),
    queryFn: () => fetchFirmwareCount(modelId, params),
    enabled: modelId > 0,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
